var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whatsapp-svgrepo-com 1",
    clipPath: "url(#clip0_2066_797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 24L2.064 17.8084C1.01669 16.0469 0.413793 13.9912 0.413793 11.7931C0.413793 5.28 5.69379 0 12.2069 0C18.72 0 24 5.28 24 11.7931C24 18.3062 18.72 23.5862 12.2069 23.5862C10.2252 23.5862 8.35903 23.095 6.72 22.2319L0 24Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.7302 15.7181C19.1856 14.689 17.1775 13.5121 17.1775 13.5121C16.7231 13.2531 16.1749 13.2241 15.9158 13.6859C15.9158 13.6859 15.2633 14.4684 15.0973 14.581C14.3393 15.0945 13.6371 15.0746 12.9282 14.3658L11.2809 12.7185L9.63361 11.0712C8.92478 10.3623 8.90492 9.66014 9.41844 8.90207C9.53099 8.73614 10.3135 8.08358 10.3135 8.08358C10.7753 7.82414 10.7463 7.27627 10.4873 6.82193C10.4873 6.82193 9.31044 4.81379 8.28133 4.26924C7.84354 4.03752 7.30602 4.11862 6.95596 4.46869L6.22851 5.19614C3.92078 7.50386 5.05706 10.1091 7.36478 12.4168L9.47389 14.5259L11.583 16.635C13.8907 18.9428 16.496 20.079 18.8037 17.7713L19.5311 17.0439C19.8812 16.693 19.9619 16.1554 19.7302 15.7181Z",
    fill: "#F0DE00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2066_797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.fca3c56851baa9591510dbace36f1daa.svg";
export { ForwardRef as ReactComponent };